import { useEffect } from 'react';
import useWebsite from 'Hooks/useWebsite';
import { pageView } from 'analytics';
import WebsiteDashboardV2 from '../../WebsiteDashboardV2';
import { WebsiteType } from 'modules/Const';
import Loader from 'elements/Loader';

const { RECORD_STREAMS, DATA_COLLECTOR } = WebsiteType;

const WebsiteAnalyticsTab = (): JSX.Element => {
    const {
        brandContent,
        websiteType,
        getWebsiteData
    } = useWebsite();

    useEffect(() => {
        let type;
        switch (websiteType) {
            case RECORD_STREAMS:
                type = 'music';
                break;
            case DATA_COLLECTOR:
                type = 'data collector';
                break;
            default:
                type = 'pre-save';
        }

        pageView('Website Specific Analytics', { type });
    }, []);

    if (!brandContent || !websiteType) {
        return (
            <Loader color='purple' />
        )
    }

    return (
        <WebsiteDashboardV2
            id={brandContent.id}
            slug={brandContent.slug}
            websiteType={websiteType}
            handleRefreshData={getWebsiteData}
            brandContent={brandContent}
        />
    );
};

export default WebsiteAnalyticsTab;